import React, { useState, useEffect } from "react";
import {
  Box,
  Avatar,
  Typography,
  TextField,
  Button,
  MenuItem,
  Paper,
} from "@mui/material";

import Female from "../../assets/female.png";
import Male from "../../assets/male.png";
import Default from "../../assets/da.png";

import { useApiRequest } from "../Login/Hooks/useApiRequest";
import backArrow from "../../assets/backArrow.png";
import { API_BASE_URL } from "../../config";
/* 🔹 Gender normalize helper */
const normalizeGender = (gender) => {
  if (!gender) return "other";

  const g = gender.toLowerCase();
  if (g === "male" || g === "m") return "male";
  if (g === "female" || g === "f") return "female";
  return "other";
};

const EditProfile = ({
  setEditProfile,
  profileData,
  onUpdate,
  fetchUserDetails,
}) => {
  const { makeApiRequest } = useApiRequest();

  const [form, setForm] = useState({
    name: "",
    gender: "other",
    email: "",
    phone: "",
  });

  /* 🔹 Set form from API */
  useEffect(() => {
    if (profileData) {
      setForm({
        name: profileData.name || "",
        gender: normalizeGender(profileData.gender),
        email: profileData.emailId || "",
        phone: profileData.mobileNo || "",
      });
    }
  }, [profileData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* 🔹 Avatar Image Logic */
  const avatarImage =
    form.gender === "female"
      ? Female
      : form.gender === "male"
      ? Male
      : Default;

  /* 🔹 API Success */
  const handleSuccess = () => {
    fetchUserDetails();
    if (onUpdate) onUpdate(form);
    setEditProfile(false);
  };

  const handleError = (err) => {
    console.error("Profile update error", err);
  };

  const handleSubmit = () => {
    const token = localStorage.getItem("token");

    makeApiRequest({
    
      url: `${API_BASE_URL}/auth/user/profile/update`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      data: {
        request: {
          firstName: form.name,
          gender: form.gender,
          emailId: form.email,
        },
      },
      handleSuccess,
      handleError,
    });
  };

  return (
    <Box>
      {/* 🔹 Header */}
      <Box
        sx={{
          position: "relative",
          background: "linear-gradient(180deg, #FFEB3B 0%, #FFE082 100%)",
          height: 100,
          //borderBottomLeftRadius: 100,
          //borderBottomRightRadius: 100,
        }}
      >
        <Box display="flex" padding="20px" alignItems={"center"}>
          <img
            src={backArrow}
            alt="back"
            style={{ width: 25, height: 20, cursor: "pointer" }}
            onClick={() => setEditProfile(false)}
          />

          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontSize: 18, color: "#583C43" }}
            style={{marginLeft:"15px"}}
          >
            
            Edit Profile
          </Typography>
        </Box>

        {/* 🔹 Dynamic Avatar */}
        <Avatar
          src={avatarImage}
          sx={{
            width: 90,
            height: 90,
            position: "absolute",
            bottom: -45,
            left: "50%",
            transform: "translateX(-50%)",
            border: "4px solid white",
            backgroundColor: "#fff",
          }}
        />
      </Box>

      {/* 🔹 Form */}
      <Paper
        elevation={0}
        sx={{
          px: 3,
          pt: 6,
          pb: 4,
          textAlign: "center",
          backgroundColor: "transparent",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {form.name}
        </Typography>

        <Typography variant="body2" sx={{ color: "gray", mb: 3 }}>
          {form.email}
        </Typography>

        <TextField
          label="Full Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />

        <TextField
          select
          label="Gender"
          name="gender"
          value={form.gender}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 ,textAlign:"justify"}}
        >
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </TextField>

        <TextField
          label="Email ID"
          name="email"
          value={form.email}
          onChange={handleChange}
          fullWidth
          sx={{ mb: 2 }}
        />

        <TextField
          label="Mobile Number"
          name="phone"
          value={form.phone}
          disabled
          fullWidth
          sx={{ mb: 3 }}
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          fullWidth
          sx={{
            backgroundColor: "#00B177",
            borderRadius: "10px",
            fontWeight: 600,
            py: 1.2,
            "&:hover": { backgroundColor: "#009e6b" },
          }}
        >
          Update Profile
        </Button>
      </Paper>
    </Box>
  );
};

export default EditProfile;
